const LIST_LAYOUT = {
  PLAIN: 'PLAIN',
  IR: 'IR',
  RAMAN: 'RAMAN',
  UVVIS: 'UV/VIS',
  H1: '1H',
  C13: '13C',
  F19: '19F',
  P31: '31P',
  N15: '15N',
  Si29: '29Si',
  MS: 'MS',
  TGA: 'THERMOGRAVIMETRIC ANALYSIS',
  XRD: 'X-RAY DIFFRACTION',
  HPLC_UVVIS: 'HPLC UV/VIS',
  CYCLIC_VOLTAMMETRY: 'CYCLIC VOLTAMMETRY',
  CDS: 'CIRCULAR DICHROISM SPECTROSCOPY',
  SEC: 'SIZE EXCLUSION CHROMATOGRAPHY',
  AIF: 'AIF',
  EMISSIONS: 'Emissions',
  DLS_ACF: 'DLS ACF',
  DLS_INTENSITY: 'DLS intensity',
  DSC: 'DIFFERENTIAL SCANNING CALORIMETRY',
  GC: 'GAS CHROMATOGRAPHY',
  LC_MS: 'LC/MS',
};

export {
  LIST_LAYOUT,  // eslint-disable-line
};
